import BtnConfigForm from './form.vue';

export default BtnConfigForm;
